var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Row, Col } from "react-bootstrap";
import { Emoji } from "emoji-mart";
import { get } from "lodash";
import authentication from "@irati/auth";
import id from "@irati/utils/id";
import { injectIntl, FormattedMessage } from "@irati/utils/lang";
import { H2 } from "@irati/ui/src/Headings";
import { Para } from "@irati/ui/src/Labels";
import { AccordionItem } from "@irati/ui/src/Accordion";
import Link from "@irati/ui/src/Link";
import Modal from "@irati/ui/src/Modal";
import medicalTracking from "@irati-tracking/medical";
import isMobileDevice from "@irati/utils/mobile";
import { Grid, TextMeInstructions, TellMeMore, ElevatedCard } from "../../../components/shared";
import ContinueOnline from "../../../components/ContinueOnline";
import Popup from "../../../components/Popup";
import MakeAClaim from "../../../components/MakeAClaim";
import LiveChat from "../../../components/LiveChat";
import HelpEmail from "../../../components/HelpEmail";
import Video from "../../../components/Video";
import { MY_MEDICAL } from "../../../constants/tracking";
import { Flex, InstructionsButton, InfoSections, EmailUsAtPara, Accordions, MarginLeft } from "./styled";
var MEDICAL_DEFAULT_PHONENUMBER = "01111111111";
var MEDICAL_DEFAULT_ACTIVATIONCODE = "activationCode";
var MEDICAL_DEFAULT_EMAIL = "medical-test-email@mailinator.com";
var MyMedical = /** @class */ (function (_super) {
    __extends(MyMedical, _super);
    function MyMedical(props) {
        var _this = _super.call(this, props) || this;
        _this.showModal = function (title) {
            var formatMessage = _this.props.formatMessage;
            var trackingLocation = formatMessage({ id: title });
            medicalTracking.viewMoreInfo(_this.props.user.activationCode, trackingLocation);
            _this.setState({ show: true, title: title });
        };
        _this.hideModal = function () {
            _this.setState({ show: false });
        };
        _this.closeAccordions = function (currentRef) {
            var shouldOpen = !currentRef.current.state.isExpanded;
            if (currentRef !== _this.bookConsultationAccordion) {
                _this.bookConsultationAccordion.current.close();
            }
            if (_this.makeAClaimAccordion.current && currentRef !== _this.makeAClaimAccordion) {
                _this.makeAClaimAccordion.current.close();
            }
            if (currentRef !== _this.membershipCertificateAccordion) {
                _this.membershipCertificateAccordion.current.close();
            }
            if (shouldOpen) {
                currentRef.current.open();
            }
        };
        _this.handleMembershipCertificateClick = function () {
            medicalTracking.downloadCertificate(_this.props.user.activationCode);
        };
        _this.handleMakeAClaimClick = function () {
            medicalTracking.makeClaim(_this.props.user.activationCode);
        };
        _this.handleContinueOnline = function () {
            medicalTracking.continueOnline(_this.props.user.activationCode, MY_MEDICAL);
        };
        _this.state = {
            show: false,
            title: null
        };
        _this.bookConsultationAccordion = React.createRef();
        _this.makeAClaimAccordion = React.createRef();
        _this.membershipCertificateAccordion = React.createRef();
        medicalTracking.viewHome(props.user.activationCode);
        return _this;
    }
    MyMedical.prototype.render = function () {
        var _this = this;
        var idNamespace = id("my-medical", this.props);
        var _a = this.state, show = _a.show, title = _a.title;
        var _b = this.props, formatMessage = _b.formatMessage, isPhone = _b.isPhone, _c = _b.user, _d = _c.activationCode, activationCode = _d === void 0 ? MEDICAL_DEFAULT_ACTIVATIONCODE : _d, _e = _c.phoneNumber, phoneNumber = _e === void 0 ? MEDICAL_DEFAULT_PHONENUMBER : _e, _f = _c.email, email = _f === void 0 ? MEDICAL_DEFAULT_EMAIL : _f;
        var hasTier2Access = authentication.apps("medical.tiers.tier2");
        var hasTier3Access = authentication.apps("medical.tiers.tier3");
        return (React.createElement(Grid, null,
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12, sm: 6 },
                    React.createElement(H2, { base: true },
                        React.createElement(FormattedMessage, { id: "medical.myMedical.heading" })),
                    isPhone && React.createElement(Video, null),
                    React.createElement(Para, { large: true },
                        React.createElement(FormattedMessage, { id: "medical.myMedical.para" })),
                    React.createElement(InfoSections, null,
                        React.createElement(TellMeMore, { onClick: this.showModal, emoji: "female-doctor", title: "medical.information.onlineGPconsultations.title" }),
                        React.createElement(TellMeMore, { onClick: this.showModal, emoji: "memo", title: "medical.information.prescriptionService.title" }),
                        hasTier2Access && (React.createElement(Fragment, null,
                            React.createElement(TellMeMore, { onClick: this.showModal, emoji: "thermometer", title: "medical.information.diagnosticInvestigations.title" }),
                            React.createElement(TellMeMore, { onClick: this.showModal, emoji: "muscle", title: "medical.information.physiotherapy.title" }))),
                        hasTier3Access &&
                            React.createElement(Fragment, null,
                                React.createElement(TellMeMore, { onClick: this.showModal, emoji: "busts_in_silhouette", title: "medical.information.specialists.title" }),
                                React.createElement(TellMeMore, { onClick: this.showModal, emoji: "male-doctor", title: "medical.information.hospitalCharges.title" }),
                                React.createElement(TellMeMore, { onClick: this.showModal, emoji: "bed", title: "medical.information.homeNursing.title" }),
                                React.createElement(TellMeMore, { onClick: this.showModal, emoji: "pound", title: "medical.information.NHScashBenefit.title" }),
                                React.createElement(TellMeMore, { onClick: this.showModal, emoji: "speaking_head_in_silhouette", title: "medical.information.mentalHealthCounselling.title" }))),
                    React.createElement(ElevatedCard, null,
                        React.createElement(Para, { large: true, bold: true },
                            React.createElement(FormattedMessage, { id: "medical.myMedical.help.title" })),
                        React.createElement(Para, null,
                            React.createElement(FormattedMessage, { id: "medical.myMedical.help.para" })),
                        React.createElement(Flex, null,
                            React.createElement(Emoji, { emoji: { id: "iphone" }, size: 14, set: "apple" }),
                            React.createElement(LiveChat, null),
                            React.createElement(EmailUsAtPara, null,
                                React.createElement(FormattedMessage, { id: "medical.myMedical.help.emailUsAt" }))),
                        React.createElement(Flex, null,
                            React.createElement(Emoji, { emoji: { id: "e-mail" }, size: 14, set: "apple" }),
                            React.createElement(HelpEmail, null)))),
                React.createElement(Col, { xs: 12, sm: 6 },
                    !isPhone && React.createElement(Video, null),
                    React.createElement(Accordions, null,
                        React.createElement("div", { onClick: function () { return _this.closeAccordions(_this.bookConsultationAccordion); } },
                            React.createElement(AccordionItem, { ref: this.bookConsultationAccordion, id: id("accordionItemConsultation", idNamespace), title: formatMessage({ id: "medical.myMedical.accordionItem.bookConsultation.title" }) },
                                isMobileDevice() ?
                                    React.createElement(React.Fragment, null,
                                        React.createElement(Para, { large: true, light: true },
                                            React.createElement(FormattedMessage, { id: "medical.myMedical.openApp.text1" }),
                                            React.createElement(MarginLeft, null,
                                                React.createElement(Emoji, { emoji: { id: "thumbsup" }, size: 14, set: "apple" }))),
                                        React.createElement(Para, { large: true, light: true },
                                            React.createElement(FormattedMessage, { id: "medical.myMedical.openApp.text2" })),
                                        React.createElement(Para, { large: true, light: true },
                                            React.createElement(FormattedMessage, { id: "medical.myMedical.openApp.text3" }))) :
                                    React.createElement(Para, { large: true, light: true },
                                        React.createElement(FormattedMessage, { id: "medical.myMedical.accordionItem.bookConsultation.para" })),
                                React.createElement(InstructionsButton, null,
                                    React.createElement(TextMeInstructions, { isFull: true, phoneNumber: phoneNumber, activationCode: activationCode, trackingLocation: MY_MEDICAL })),
                                React.createElement(ContinueOnline, { onClick: this.handleContinueOnline, activationCode: activationCode, link: "medical.myMedical.accordionItem.bookConsultation.href", text: "medical.myMedical.accordionItem.bookConsultation.link" }))),
                        hasTier2Access &&
                            React.createElement("div", { onClick: function () { return _this.closeAccordions(_this.makeAClaimAccordion); } },
                                React.createElement(AccordionItem, { ref: this.makeAClaimAccordion, id: id("accordionItemMakeAClaim", idNamespace), title: formatMessage({ id: "medical.myMedical.accordionItem.makeAClaim.title" }) },
                                    React.createElement(MakeAClaim, { onClick: this.handleMakeAClaimClick }))),
                        React.createElement("div", { onClick: function () { return _this.closeAccordions(_this.membershipCertificateAccordion); } },
                            React.createElement(AccordionItem, { ref: this.membershipCertificateAccordion, id: id("accordionItemMembershipCertificate", idNamespace), title: formatMessage({ id: "medical.myMedical.accordionItem.membershipCertificate.title" }) },
                                React.createElement(Para, null,
                                    React.createElement(FormattedMessage, { id: "medical.myMedical.accordionItem.membershipCertificate.para", values: { email: email } }))))),
                    React.createElement(Para, null,
                        React.createElement(FormattedMessage, { id: "medical.myMedical.privacy.para" })),
                    React.createElement(Para, null,
                        React.createElement(FormattedMessage, { id: "medical.myMedical.privacy.link.start" }),
                        React.createElement(Link, { inBody: true, uppercase: false, href: formatMessage({ id: "medical.privacyPolicy.href" }), target: "_blank", rel: "noopener noreferrer" },
                            React.createElement(FormattedMessage, { id: "platform.footer.href.privacyPolicy.text" })),
                        React.createElement(FormattedMessage, { id: "medical.myMedical.privacy.link.end" })))),
            React.createElement(Modal, { show: show, onHide: this.hideModal },
                React.createElement(Popup, { title: title, activationCode: activationCode }))));
    };
    return MyMedical;
}(Component));
var mapStateToProps = function (_a) {
    var mq = _a.mq;
    return ({
        isPhone: get(mq, "lessThan.medium", false)
    });
};
export default injectIntl(connect(mapStateToProps)(MyMedical));
